import { lazy } from 'react';

// Auth pages (standalone, no layout)
export const MaintenanceAuth = lazy(() => import('@/pages/MaintenanceAuth'));
export const VendorAuth = lazy(() => import('@/pages/VendorAuth'));
export const VendorTechAuth = lazy(() => import('@/pages/VendorTechAuth'));
export const VendorShieldProAuth = lazy(() => import('@/pages/VendorShieldProAuth'));
export const TenantAuth = lazy(() => import('@/pages/TenantAuth'));
export const MaintenanceTeam = lazy(() => import('@/pages/MaintenanceTeam'));
export const VendorDashboard = lazy(() => import('@/pages/VendorDashboard'));
export const VendorTech = lazy(() => import('@/pages/VendorTech'));
export const AuthLandingPage = lazy(() => import('@/components/auth/landing/AuthLandingPage'));
export const NotFound = lazy(() => import('@/pages/NotFound'));
export const ComingSoon = lazy(() => import('@/pages/ComingSoon'));
export const CompanyOnboarding = lazy(() => import('@/pages/CompanyOnboarding'));

// Core pages
export const OperationsCenter = lazy(() => import('@/pages/OperationsCenter'));
export const AnalyticsDashboard = lazy(() => import('@/pages/AnalyticsDashboard'));

// Property pages
export const Properties = lazy(() => import('@/pages/Properties'));
export const PropertyView = lazy(() => import('@/pages/PropertyView'));
export const AddProperty = lazy(() => import('@/pages/AddProperty'));
export const DocumentVaultPage = lazy(() => import('@/pages/DocumentVault'));

// Vendor pages
export const VendorDispatchPage = lazy(() => import('@/pages/VendorDispatchPage'));
export const VendorShieldPro = lazy(() => import('@/pages/VendorShieldPro'));
export const Vendors = lazy(() => import('@/pages/Vendors'));
export const VendorManagementPage = lazy(() => import('@/pages/VendorManagementPage'));
export const VendorCompanyPortal = lazy(() => import('@/pages/VendorCompanyPortal'));
export const VendorOnboarding = lazy(() => import('@/pages/VendorOnboarding'));

// Maintenance pages
export const MaintenanceDashboard = lazy(() => import('@/pages/MaintenanceDashboard'));
export const WorkOrders = lazy(() => import('@/pages/WorkOrders'));

// Emergency pages
export const EmergencyPlans = lazy(() => import('@/pages/EmergencyPlans'));
export const EmergencyPlanView = lazy(() => import('@/pages/EmergencyPlanView'));
export const EmergencyResponse = lazy(() => import('@/pages/EmergencyResponse'));
export const FirstResponder = lazy(() => import('@/pages/FirstResponder'));
export const EmergencyPlanBuilderPage = lazy(() => import('@/pages/EmergencyPlanBuilder'));

// Tenant pages
export const TenantApp = lazy(() => import('@/pages/TenantApp'));
export const TenantEngagement = lazy(() => import('@/pages/TenantEngagement'));
export const KioskPreview = lazy(() => import('@/pages/KioskPreview'));

// Management pages
export const DocumentIntelligenceCenter = lazy(() => import('@/pages/DocumentIntelligenceCenter'));
export const LossManagement = lazy(() => import('@/pages/LossManagement'));
export const LossControl = lazy(() => import('@/pages/LossControl'));
export const InsuranceClaims = lazy(() => import('@/pages/InsuranceClaims'));
export const InsuranceOptimization = lazy(() => import('@/pages/InsuranceOptimization'));
export const Reports = lazy(() => import('@/pages/Reports'));
export const AnalyticsEnginePage = lazy(() => import('@/pages/AnalyticsEngine'));
export const RiskMapping = lazy(() => import('@/pages/RiskMapping'));
export const LenderRiskAssessment = lazy(() => import('@/pages/LenderRiskAssessment'));
export const SmartOperationsCalendar = lazy(() => import('@/pages/SmartOperationsCalendar'));
export const Communications = lazy(() => import('@/pages/Communications'));
export const Alerts = lazy(() => import('@/pages/Alerts'));
export const CreateAlert = lazy(() => import('@/pages/CreateAlert'));
export const Settings = lazy(() => import('@/pages/Settings'));
export const TechManagement = lazy(() => import('@/pages/TechManagement'));
export const SuperAdminDashboard = lazy(() => import('@/pages/SuperAdminDashboard'));
export const IndoorPositioningAdmin = lazy(() => import('@/pages/admin/IndoorPositioningAdmin'));
export const DevTeamAdmin = lazy(() => import('@/pages/admin/DevTeamAdmin'));
export const APIPortal = lazy(() => import('@/pages/APIPortal'));
export const BaselineCollection = lazy(() => import('@/pages/admin/BaselineCollection'));
export const ConciergeDashboardPage = lazy(() => import('@/pages/ConciergeDashboard'));
export const WaterScorecardPage = lazy(() => import('@/pages/internal/WaterScorecard'));
export const SurveysPage = lazy(() => import('@/pages/admin/SurveysPage'));
export const TenantSurveyPage = lazy(() => import('@/pages/public/TenantSurveyPage'));
export const PrintableSurvey = lazy(() => import('@/components/surveys/PrintableSurvey'));
export const PrintableSurveyFlyer = lazy(() => import('@/components/surveys/PrintableSurveyFlyer'));
export const FounderCommand = lazy(() => import('@/pages/admin/FounderCommand'));
export const AdminHub = lazy(() => import('@/pages/admin/AdminHub'));

// AI pages
export const AnalyticsAI = lazy(() => import('@/pages/AnalyticsAI'));
export const AIPredictiveMaintenanceHub = lazy(() => import('@/components/ai/AIPredictiveMaintenanceHub'));
export const AIVendorDispatchIntelligence = lazy(() => import('@/components/ai/AIVendorDispatchIntelligence'));
export const IoTIntegrationHub = lazy(() => import('@/components/ai/IoTIntegrationHub'));
export const WhatIfAnalysis = lazy(() => import('@/pages/WhatIfAnalysis'));
export const ResolutionCoach = lazy(() => import('@/pages/ResolutionCoach'));
export const IntelligenceReporting = lazy(() => import('@/pages/IntelligenceReporting'));
export const AICommunicationEngine = lazy(() => import('@/pages/AICommunicationEngine'));
export const AIAnalyticsDashboard = lazy(() => import('@/components/ai/AIAnalyticsDashboard'));
export const FeedbackAnalytics = lazy(() => import('@/pages/FeedbackAnalytics'));
